module.exports = __webpack_public_path__ + "static/img/W600.e5f602f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/W600.png
// module id = M2r0
// module chunks = 12